export const Functions = {
  create: false,
  delete: false,
  detail: true,
  search: false,
};

export const PageName = '爱心传递项目订单';
